function isSuccess(action) {
  // Only reset guard modified state on update success.
  return action.type.endsWith('-success');
}

function shouldReset(action) {
  return action.meta && action.meta.resetModifiedOnSuccess;
}

function shouldMark(action) {
  // Do not set guard modified state on UI-only actions, i.e. actions
  // that do not trigger model changes and need not be guarded.
  return !(action.meta && action.meta.uiAction);
}

export default function changeGuardReducer(modified, action) {
  if (typeof modified === 'undefined') return false;

  if (shouldReset(action)) {
    if (isSuccess(action)) return false;
  } else if (shouldMark(action)) {
    return true;
  }

  return modified;
}
